import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDataInput, TManagerScriptSettings, TWebsocketScriptSettings } from "../../../../../interface/interfaces";

interface IInitialState{
    scriptUpdateManagerData: TManagerScriptSettings[],
    scriptUpdateManagerLoading: boolean,
    scriptUpdateManagerError: string,
    scriptUpdateWsData: TWebsocketScriptSettings[],
    scriptUpdateWsLoading: boolean
}

const initialState: IInitialState = {
    scriptUpdateManagerData: [],
    scriptUpdateManagerLoading: false,
    scriptUpdateManagerError: '',
    scriptUpdateWsData: [],
    scriptUpdateWsLoading: false
};

const scriptUpdateSlice = createSlice({
    name: 'scriptUpdate',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchScriptUpdateManagerPending: (state: IInitialState, action: PayloadAction<IDataInput>) => {
            state.scriptUpdateManagerLoading = true;
            state.scriptUpdateManagerError = '';
        },
        fetchScriptUpdateManagerFulfilled: (state: IInitialState, action: PayloadAction<TManagerScriptSettings[]>) => {
            state.scriptUpdateManagerLoading = false;
            state.scriptUpdateManagerData = action.payload;
            state.scriptUpdateManagerError = '';
        },
        fetchScriptUpdateManagerFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.scriptUpdateManagerLoading = false;
            state.scriptUpdateManagerError = action.payload;
        },
        clearScriptUpdateManagerData: (state: IInitialState) => {
            state.scriptUpdateManagerLoading = false;
            state.scriptUpdateManagerError = '';
            state.scriptUpdateManagerData = [];
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        scriptUpdateWsLoading: (state: IInitialState, action: PayloadAction<boolean>) => {
            state.scriptUpdateWsLoading = action.payload;
        },
        saveScriptUpdateWsData: (state: IInitialState, action: PayloadAction<TWebsocketScriptSettings[]>) => {
            state.scriptUpdateWsLoading = false;
            state.scriptUpdateWsData = action.payload;
        },
    },

})

export default scriptUpdateSlice.reducer;
export const {
    fetchScriptUpdateManagerPending,
    fetchScriptUpdateManagerFulfilled,
    fetchScriptUpdateManagerFailure,
    clearScriptUpdateManagerData,
    saveScriptUpdateWsData,
    scriptUpdateWsLoading
} = scriptUpdateSlice.actions;